export default "__VITE_ASSET__Dd3BFN$Z__"